// React Query
import { UseMutationResult } from '@tanstack/react-query';

import { useMutationQuery } from 'api/utils/queries';
import { createReport } from 'api/utils/queries/createReport';
import { ReportType } from 'interfaces';

// Interfaces
interface pdfData {
  type: string;
  userID?: string;
  siteID?: string;
  providerID?: string;
  s3Path: string;
  selectedTariffIDs?: string[];
  includeCoverLetter?: boolean;
  includeWCBForm?: boolean;
  includeWCBInvoice?: boolean;
  replaceInvoiceID?: string;
}

export interface PDFResponse {
  url: string;
  statusCode?: number;
}

export const reportQueryKeys = {
  all: ['reports'],
};

const reportSuccessMessage =
  'Your report is being created. We will notify you via email when it is ready!';

const generateClaimQuery = async (data: pdfData): Promise<PDFResponse> =>
  createReport({
    path: '/action/generate/query',
    params: data,
    functionName: 'claimQuery',
  });

const generateClaimInvoice = async (data: pdfData): Promise<PDFResponse> =>
  createReport({
    path: '/action/generate/invoice',
    params: data,
    functionName: 'claimInvoice',
  });

export const useGenerateClaimQuery = (): UseMutationResult<PDFResponse> =>
  useMutationQuery<PDFResponse>({
    mutationFn: generateClaimQuery,
    errorMessage: 'Failed to create Report',
    successMessage: reportSuccessMessage,
    displayNotification: false,
    queryKey: reportQueryKeys.all,
  });

export const useGenerateClaimInvoice = (): UseMutationResult<PDFResponse> =>
  useMutationQuery<PDFResponse>({
    mutationFn: generateClaimInvoice,
    errorMessage: 'Failed to create Report',
    successMessage: '',
    queryKey: reportQueryKeys.all,
    displayNotification: false,
  });

export const generateReportV2 = async <Payload extends object>(
  type: ReportType,
  payload: Payload
): Promise<PDFResponse> =>
  await createReport({
    path: `/action/generate/pdf`,
    params: { type, payload },
    functionName: 'generateReportV2',
  });
